import { FlagThumbnail } from './FlagThumbnail'
import type { Order } from '../types'

const MAX_SHOWN = 4

export function FlagStrip({ flags }: { flags: Order['flags'] }) {
  if (flags.length === 0) {
    return <span style={{ color: 'var(--color-muted)', fontSize: 13 }}>—</span>
  }
  const shown = flags.slice(0, MAX_SHOWN)
  const overflow = flags.length - MAX_SHOWN

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      {shown.map((f) => (
        <div key={f.id} title={f.name + (f.type === 'custom' ? ' (Eigene)' : '')}>
          <FlagThumbnail id={f.id} type={f.type} imageUrl={f.image_url} name={f.name} width={36} height={22} />
        </div>
      ))}
      {overflow > 0 && (
        <span style={{ fontSize: 12, color: 'var(--color-muted)', marginLeft: 2 }}>+{overflow}</span>
      )}
    </div>
  )
}
